import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";
import { errorHandling } from "../../helper";

const templeSlice = createSlice({
  name: "homePage",
  initialState: {
    loading: false,
    customerSharedImages: [],
    banners: [],
  },
  reducers: {
    loading: (state, action) => {
      state.loading = action.payload;
    },
    getCustomerShared: (state, action) => {
      state.customerSharedImages = action.payload;
    },
    getBanners: (state, action) => {
      state.banners = action.payload;
    },
  },
});

export const { loading, getCustomerShared, getBanners } = templeSlice.actions;

// Customer shared images:
export const getCustomerSharedImages = () => async (dispatch) => {
  try {
    dispatch(loading(true));
    const url = `${process.env.REACT_APP_API_BASE_URL}/admin-auth/get_scroller_image`;
    const { data } = await axios.get(url, {
      headers: {
        Authorization: localStorage.getItem("token"),
      },
    });
    dispatch(getCustomerShared(data));
    dispatch(loading(false));
  } catch (error) {
    dispatch(loading(false));
    errorHandling(error);
  }
};

export const deleteCustomerSharedImage = (id) => async (dispatch) => {
  try {
    dispatch(loading(true));
    const url = `${process.env.REACT_APP_API_BASE_URL}/admin-auth/remove_scroller_image/${id}`;
    const { data } = await axios.post(url,{}, {
      headers: {
        Authorization: localStorage.getItem("token"),
      },
    });
    dispatch(loading(false));
  } catch (error) {
    dispatch(loading(false));
    errorHandling(error);
  }
};


export const storeCustomerSharedImages = (formData) => async (dispatch) => {
  try {
    // console.log(formData,"file")
    dispatch(loading(true));
    const url = `${process.env.REACT_APP_API_BASE_URL}/admin-auth/store_scroller_image`;
    const { data } = await axios.post(url, formData, {
      headers: {
        Authorization: localStorage.getItem("token"),
      },
    });
    dispatch(loading(false));
  } catch (error) {
    toast.error(error.response.data.error);

    dispatch(loading(false));
    errorHandling(error);
  }
};

// Hmepage Banner
export const getBannerList = () => async (dispatch) => {
  try {
    dispatch(loading(true));
    const url = `${process.env.REACT_APP_API_BASE_URL}/admin-auth/get_homebackground_image`;
    const { data } = await axios.get(url, {
      headers: {
        Authorization: localStorage.getItem("token"),
      },
    });
    dispatch(getBanners(data));
    dispatch(loading(false));
  } catch (error) {
    dispatch(loading(false));
    errorHandling(error);
  }
};

export const deleteBanner = (id) => async (dispatch) => {
  try {
    dispatch(loading(true));
    const url = `${process.env.REACT_APP_API_BASE_URL}/admin-auth/remove_homebackground_image/${id}`;
    const { data } = await axios.post(url,{},{
      headers: {
        Authorization: localStorage.getItem("token"),
      },
    });
    dispatch(loading(false));
  } catch (error) {
    dispatch(loading(false));
    errorHandling(error);
  }
};

export const editBanner = (id,formData) => async (dispatch) => {
  try {
    dispatch(loading(true));
    const url = `${process.env.REACT_APP_API_BASE_URL}/admin-auth/update_homebackground_image/${id}`;
    const { data } = await axios.post(url,formData,{
      headers: {
        Authorization: localStorage.getItem("token"),
      },
    });
    dispatch(loading(false));
  } catch (error) {
    dispatch(loading(false));
    errorHandling(error);
  }
};

export const storeBanner = (formData) => async (dispatch) => {
  try {
    // dispatch(loading(true));
    const url = `${process.env.REACT_APP_API_BASE_URL}/admin-auth/store_homebackground_image`;
    const response= await axios.post(url, formData, {
      headers: {
        Authorization: localStorage.getItem("token"),
      },
    });
    console.log(response,"response")
    // dispatch(getBannerList())
    // dispatch(loading(false));
  } catch (error) {
    toast.error(error.response.data.error);
    dispatch(loading(false));
    errorHandling(error);
  }
};


export default templeSlice.reducer;
